import React from 'react'
// Local
import { BASE_URL } from '../../config'
import { API_URL } from '../../constant'

/**
 * Provides a component that renders a PDF encounter report in an iframe
 * @param encounterId Render iframe with PDF report for specified encounter ID
 */

type Props = {
  encounterId?: string | null | undefined
}

function PdfEncounterReport(
  props: Props
): JSX.Element | null {
  const { encounterId } = props
  if (encounterId) {
    return (
      <iframe
        title="Encounter PDF"
        className="pdf-iframe"
        src={ `${BASE_URL}${API_URL.PDF_ENCOUNTER_REPORT(encounterId)}` }
      />
    )
  }
  return null
}

export default PdfEncounterReport
